// extracted by mini-css-extract-plugin
export default {"ScreenSMMin":"(min-width: 768px)","referralCodeCopied":"G70992d","positionTop45":"Gdf1cda","mobileHide":"Gca0755 Gcfd652","mobileShow":"G14ce93 Gd99ee9","invisible":"Gc19775"};